import type { Article } from "@/types/content";

export const articles: Article[] = [
  {
    id: "lin-qingyue-candidate-bird-signal",
    title: "林清越新专辑《候鸟信号》上线：她把巡演公路写进了旋律里",
    category: "music",
    excerpt:
      "三年巡演、二十七座城市、一台随身录音笔，这张专辑几乎是在路上写完的。林清越说，她想留住的是车窗外面一闪而过的那些瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=indie%20singer%20songwriting%20concept%20abstract%20collage%20of%20highway%20line%20and%20sound%20wave%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-01-2026&orientation=landscape",
    author: "瓜田音乐组",
    publishedAt: "2026-09-12",
    readMinutes: 6,
    views: 18420,
    heat: 986,
    tags: ["新专辑", "巡演", "独立音乐"],
    featured: true,
    trending: true,
    content: [
      {
        text: "《候鸟信号》在凌晨上线，没有预热海报，没有倒计时直播，只有一条不到二十字的动态：路上写的，路上发。这张被乐迷等了两年多的专辑，就这样安静地来了。",
      },
      {
        heading: "一台录音笔和二十七座城市",
        text: "从北方的旧工业城市到南方沿海的小镇，林清越把巡演路上的碎片都收进了一台随身录音笔。地铁报站声、海边夜市的嘈杂、凌晨排练室里断断续续的和弦，后来都变成了编曲里那些很难被一眼指认的细节。",
      },
      {
        heading: "为什么不做一首所谓的主打歌",
        text: "面对“为什么第一首不打爆款”的提问，她的回答很直接：如果每张专辑都从主打歌开始思考，音乐就变成了填空。她宁愿让听众从第二首、第五首里自己去找到那首属于他们的歌。",
      },
      {
        text: "专辑上线后的第一晚，乐评区的讨论从旋律聊到了歌词里反复出现的“信号”二字。有人说是关于告别，有人说是关于等待，林清越没有给出标准答案，只在评论区留了一句：你们听到什么，它就是什么。",
      },
    ],
  },
  {
    id: "film-dawn-city-review",
    title: "《破晓之城》口碑出炉：一场关于选择的都市寓言",
    category: "film",
    excerpt:
      "没有宏大场面，把镜头收进一条老街和三个普通人身上。这部成本不高的都市片，却让很多观众在散场后坐到了字幕放完。",
    cover:
      "https://readdy.ai/api/search-image?query=urban%20drama%20film%20abstract%20collage%20of%20city%20skyline%20window%20and%20dawn%20light%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-02-2026&orientation=landscape",
    author: "瓜田影视组",
    publishedAt: "2026-09-11",
    readMinutes: 7,
    views: 15230,
    heat: 941,
    tags: ["新片点映", "口碑", "都市"],
    featured: true,
    trending: true,
    content: [
      {
        text: "《破晓之城》片长一百零九分钟，其中近四十分钟发生在一间不足二十平米的早餐店里。导演说，他想拍的不是城市，而是城市里那些被时间推着走的人。",
      },
      {
        heading: "三个普通人，三种选择",
        text: "夜班司机、即将关店的老板娘、刚失业的年轻人，三条线索在同一个清晨交汇。影片没有给出谁是对的，而是让每个人都在自己的处境里做出了那个当下最合理的选择。",
      },
      {
        heading: "为什么它能让人坐到最后",
        text: "点映现场，不少观众直到字幕结束才起身。不是因为彩蛋，而是因为结尾那个长镜头里，早餐店的灯又重新亮了起来——导演把这个留白，交给了每一位观众。",
      },
      {
        text: "口碑发酵后，讨论最多的其实是配乐：全片几乎没有完整旋律，只有环境声与偶尔响起的收音机。有观众评价，这种克制反而让情绪更满。",
      },
    ],
  },
  {
    id: "variety-slow-life-season-3",
    title: "《慢慢来》第三季开播：把镜头交给菜市场和老手艺",
    category: "variety",
    excerpt:
      "没有任务，没有淘汰，这一季的嘉宾只是在不同的城市住上几天。节目组说，他们这次最大的改变，是学会了不打扰。",
    cover:
      "https://readdy.ai/api/search-image?query=slow%20life%20variety%20show%20abstract%20collage%20of%20market%20basket%20and%20sunlight%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-03-2026&orientation=landscape",
    author: "瓜田综艺组",
    publishedAt: "2026-09-10",
    readMinutes: 5,
    views: 12890,
    heat: 903,
    tags: ["慢综艺", "开播", "口碑"],
    featured: true,
    content: [
      {
        text: "《慢慢来》第三季首期把摄制组缩小到了十二人，比第一季少了将近一半。制片人在看片会上说，人多的时候，镜头会忍不住去找事，人少了，反而敢等。",
      },
      {
        heading: "菜市场里的一天",
        text: "首期嘉宾在一座南方小城的菜市场待了整整一天，从清晨进货到傍晚收摊。没有剧本冲突，镜头记录下的只是讨价还价、熟客寒暄，以及摊主递过来的一小把香菜。",
      },
      {
        heading: "老手艺的两次停顿",
        text: "在一位做了四十多年竹编的老师傅家里，嘉宾尝试上手，连续两次失败。节目没有剪掉这些停顿，而是完整保留了下来。有观众留言：原来慢慢来这三个字，是真的慢。",
      },
    ],
  },
  {
    id: "su-han-red-carpet-wardrobe",
    title: "苏晗红毯造型幕后：一件礼服改了三十次",
    category: "star",
    excerpt:
      "红毯上走过的只有短短几十秒，但为了这几十秒，造型团队提前两个月就开始准备。我们找到了这次造型的幕后故事。",
    cover:
      "https://readdy.ai/api/search-image?query=red%20carpet%20fashion%20abstract%20collage%20of%20dress%20silhouette%20and%20spotlight%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-04-2026&orientation=landscape",
    author: "瓜田时尚组",
    publishedAt: "2026-09-09",
    readMinutes: 6,
    views: 20110,
    heat: 968,
    tags: ["红毯", "造型", "幕后"],
    trending: true,
    content: [
      {
        text: "苏晗走完红毯后，造型师在社交媒体上发了一张版型草图，配文只有一个数字：30。后来大家才知道，那是这件礼服被修改的次数。",
      },
      {
        heading: "从一块面料开始",
        text: "礼服的面料是团队在某次出差时偶然买下的，底色偏暖，在舞台灯光下会呈现出微微的变化。为了配合这个特性，腰线被整体上移了一点五厘米，让垂坠感更顺。",
      },
      {
        heading: "被放弃的三个方案",
        text: "在最终定稿之前，团队其实做过三个方向：一个过于隆重，一个和上个月的造型太像，还有一个在现场走位时始终容易踩到裙摆。最后留下的这个，恰好是改动最多的那个。",
      },
    ],
  },
  {
    id: "spring-2026-layering-notes",
    title: "2026 春夏叠穿笔记：低饱和也能穿出存在感",
    category: "fashion",
    excerpt:
      "这一季的关键词不是亮，而是层次。我们整理了几组好上手的叠穿思路，从通勤到周末都能直接用。",
    cover:
      "https://readdy.ai/api/search-image?query=fashion%20layering%20abstract%20collage%20of%20folded%20fabric%20and%20color%20swatches%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-05-2026&orientation=landscape",
    author: "瓜田时尚组",
    publishedAt: "2026-09-08",
    readMinutes: 5,
    views: 9870,
    heat: 812,
    tags: ["穿搭", "春夏", "趋势"],
    content: [
      {
        text: "逛完这一季的秀场和订货会，最大的感受是：颜色变得更安静了，但结构变得更复杂。低饱和不等于没有存在感，关键在于层次的组织方式。",
      },
      {
        heading: "思路一：同色不同材质",
        text: "把同一色系里哑光、微光、粗糙三种质感叠在一起，视觉上会产生细微的起伏。比如米色针织外加一件略带丝光的同色衬衫，远看是一块，近看有三层。",
      },
      {
        heading: "思路二：把重心放到肩线",
        text: "肩线是这一季被讨论最多的部位。稍宽的结构配上内里收窄的下装，即使整体颜色很淡，轮廓也足够有记忆点。",
      },
      {
        text: "最后一点建议：叠穿最怕的是过满。留一处空白，比如露出的手腕或脚踝，整套搭配会立刻透气不少。",
      },
    ],
  },
  {
    id: "overseas-lumen-park-renewed",
    title: "海外剧集《暗涌公园》续订第二季，时间线将跳跃三年",
    category: "overseas",
    excerpt:
      "第一季结尾留下的疑问还没解开，制作方就宣布了续订。主创在采访中透露，第二季会把镜头对准三年后的同一群人。",
    cover:
      "https://readdy.ai/api/search-image?query=overseas%20series%20abstract%20collage%20of%20park%20trees%20and%20misty%20path%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-06-2026&orientation=landscape",
    author: "瓜田海外组",
    publishedAt: "2026-09-07",
    readMinutes: 5,
    views: 11230,
    heat: 876,
    tags: ["海外剧集", "续订", "前瞻"],
    trending: true,
    content: [
      {
        text: "《暗涌公园》第一季播出后在全球范围内积累了稳定口碑，评分与社交平台讨论度双高。续订消息公布得比预期更早，也让等待的观众松了一口气。",
      },
      {
        heading: "三年的空白期意味着什么",
        text: "主创表示，第二季不会直接接着结尾拍，而是跳跃三年后再回到这群人身边。这三年里发生了什么，将分散在各位角色的日常细节中被慢慢补全。",
      },
      {
        heading: "原班人马的取舍",
        text: "制作方确认核心演员全员回归，但同时也会加入两位新角色。新角色与旧角色的关系不是简单的替代，而是会改变整个公园的相处方式。",
      },
    ],
  },
  {
    id: "livehouse-tour-rising",
    title: "城市小剧场巡演升温：独立音乐人为什么重新爱上 Livehouse",
    category: "music",
    excerpt:
      "当大型场馆的票价越来越高，一批音乐人选择把演出搬回几百人的小场地。距离更近，故事也更多。",
    cover:
      "https://readdy.ai/api/search-image?query=livehouse%20concert%20abstract%20collage%20of%20small%20stage%20and%20crowd%20silhouette%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-07-2026&orientation=landscape",
    author: "瓜田音乐组",
    publishedAt: "2026-09-06",
    readMinutes: 6,
    views: 8420,
    heat: 764,
    tags: ["Livehouse", "巡演", "独立音乐"],
    content: [
      {
        text: "这一季的巡演地图上，出现越来越多并不大的城市，以及容量几百人的场地。对不少独立音乐人来说，回到 Livehouse 不只是情怀，更是一种更真实的工作方式。",
      },
      {
        heading: "更近的距离，更直接的反馈",
        text: "在几百人的场地里，台上能看清每一张脸的表情，观众的反应几乎是实时的。有音乐人说，这种反馈是大型场馆给不了的，它会直接影响当晚演出的状态。",
      },
      {
        heading: "账本上的现实",
        text: "当然，小场地巡演并不意味着轻松。成本、档期、器械运输都是实打实的问题。但省下来的舞台制作费用，被更多投入到了乐手与排练上，这让现场的质量反而更稳。",
      },
    ],
  },
  {
    id: "lu-shiyan-behind-the-scenes",
    title: "陆时衍谈转型幕后：演员的好奇心比镜头更重要",
    category: "star",
    excerpt:
      "从演员到监制，他用了五年时间。这次他聊了聊为什么愿意退到镜头后面，以及一个好故事到底意味着什么。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20producer%20abstract%20collage%20of%20monitor%20screen%20and%20storyboard%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-08-2026&orientation=landscape",
    author: "瓜田人物组",
    publishedAt: "2026-09-05",
    readMinutes: 7,
    views: 13650,
    heat: 890,
    tags: ["访谈", "幕后", "转型"],
    content: [
      {
        text: "采访当天，陆时衍刚结束一场长达四小时的剪辑会。他说自己现在最常待的地方，是机房而不是片场。",
      },
      {
        heading: "为什么选择退后一步",
        text: "在演了十几年戏之后，他越来越想弄清楚一件事：一个故事是怎么被搭起来的。这个问题的答案不在镜头前，而在剧本、预算和无数个需要取舍的瞬间里。",
      },
      {
        heading: "好奇心是可以被训练的",
        text: "他把监制的工作形容成持续提问：这个角色的动机成立吗？这场戏能不能再少一句台词？在他看来，好奇心不是天赋，而是可以被反复训练的能力。",
      },
      {
        text: "聊到未来的计划，他笑着说还是想演戏，但会更挑剔。因为看过幕后之后，他更清楚一个团队为了一个好故事要付出多少。",
      },
    ],
  },
  {
    id: "animation-echo-forest-preview",
    title: "动画电影《回声森林》点映：写给成年人的一则温柔寓言",
    category: "film",
    excerpt:
      "画风克制，故事安静，这部电影几乎没有反派。它想讲的，是一个关于回到自己的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=animated%20film%20abstract%20collage%20of%20forest%20layers%20and%20soft%20light%20rays%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-09-2026&orientation=landscape",
    author: "瓜田影视组",
    publishedAt: "2026-09-04",
    readMinutes: 5,
    views: 10340,
    heat: 821,
    tags: ["动画电影", "点映", "寓言"],
    content: [
      {
        text: "《回声森林》全长九十分钟，是一部没有反派的电影。主角要面对的，始终是自己。点映结束后，有观众说：它像一句被放慢了音量的安慰。",
      },
      {
        heading: "把色彩交给情绪",
        text: "影片的色彩很克制，森林不会因为剧情紧张就变得艳俗。导演说，他们希望观众感受到的不是刺激，而是一种温度，像傍晚回家的那条路。",
      },
      {
        heading: "适合谁看",
        text: "它可能不是一部适合低龄观众的动画，但对经历过选择与告别的大人来说，那些留白恰恰是它最温柔的地方。",
      },
    ],
  },
  {
    id: "variety-brain-lab-comeback",
    title: "推理综艺《脑力实验室》口碑逆袭：慢节奏也能留住观众",
    category: "variety",
    excerpt:
      "开播时被说太慢，播出过半却成了每周最被期待的节目。这档推理综艺到底做对了什么？",
    cover:
      "https://readdy.ai/api/search-image?query=reasoning%20variety%20show%20abstract%20collage%20of%20magnifier%20and%20board%20puzzle%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-10-2026&orientation=landscape",
    author: "瓜田综艺组",
    publishedAt: "2026-09-03",
    readMinutes: 5,
    views: 9130,
    heat: 779,
    tags: ["推理", "口碑", "慢节奏"],
    trending: true,
    content: [
      {
        text: "《脑力实验室》的逆袭几乎是从第四期开始的。前三期它被批评节奏偏慢、信息密度高，但坚持看下去的观众，却在后面找到了上头的乐趣。",
      },
      {
        heading: "把推理还给观众",
        text: "节目最大的特点是尽量不给提示。线索一次性放齐，观众可以暂停、回看，自己拼出答案。这种不把答案喂到嘴边的做法，恰恰筛选出了真正投入的观众。",
      },
      {
        heading: "慢，是一种选择",
        text: "总导演说，他们不是做不快，而是选择不做快。推理需要思考的时间，把节奏让给观众，节目本身的质感反而立住了。",
      },
    ],
  },
  {
    id: "vintage-bag-comeback",
    title: "中古包回潮：年轻人为什么愿意为有故事的物件买单",
    category: "fashion",
    excerpt:
      "在二手平台上，一些停产多年的款式价格稳步上涨。买中古包的人，买的到底是什么？",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20fashion%20abstract%20collage%20of%20old%20leather%20bag%20and%20craft%20tools%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-11-2026&orientation=landscape",
    author: "瓜田时尚组",
    publishedAt: "2026-09-02",
    readMinutes: 5,
    views: 7620,
    heat: 702,
    tags: ["中古", "二手时尚", "消费"],
    content: [
      {
        text: "相比追每一季的新款，越来越多的年轻人开始把目光投向中古。原因很现实：价格更友好，款式更独特，而且不用担心撞包。",
      },
      {
        heading: "时间留下的痕迹",
        text: "中古最迷人的地方，是它身上带着使用过的证据。皮面的自然氧化、五金上的细微划痕，在爱好者眼里都是加分项，是新品做不出来的质感。",
      },
      {
        heading: "理性一点的建议",
        text: "不过中古也意味着更高的挑选门槛。学会看批次、五金和皮面状态，比冲动下单重要得多。真正值得买的，永远是那只会让你想一直用下去的。",
      },
    ],
  },
  {
    id: "overseas-campfire-night-talk",
    title: "海外慢综艺《篝火夜谈》出圈：安静的内容正在被看见",
    category: "overseas",
    excerpt:
      "没有游戏，没有任务，几个人围着篝火聊天。这档节目却在社交平台上被反复转发，评论区说得最多的是被治愈了。",
    cover:
      "https://readdy.ai/api/search-image?query=campfire%20night%20talk%20abstract%20collage%20of%20bonfire%20glow%20and%20starry%20sky%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-12-2026&orientation=landscape",
    author: "瓜田海外组",
    publishedAt: "2026-09-01",
    readMinutes: 4,
    views: 8940,
    heat: 760,
    tags: ["慢综艺", "治愈", "出圈"],
    content: [
      {
        text: "《篝火夜谈》每期只做一件事：点一盏火，坐下来聊天。嘉宾不限身份，话题不限边界，节目组几乎不介入。",
      },
      {
        heading: "不剪冲突，剪留白",
        text: "节目最特别的地方，是它愿意保留沉默。一段话说完之后的几秒安静，常常比对话本身更有力量。有观众说，看着火慢慢烧，自己也跟着松了下来。",
      },
      {
        heading: "安静的流量",
        text: "在追求强刺激的内容环境里，《篝火夜谈》证明了另一种可能：安静的内容，也能找到属于它的观众。",
      },
    ],
  },
  {
    id: "gu-xingye-book-drift-plan",
    title: "顾星野发起旧书漂流计划：让阅读在城市里流动起来",
    category: "star",
    excerpt:
      "从一间咖啡馆开始，这个计划已经覆盖了十几座城市。参与的人说，最期待的不是拿到书，而是翻开时看到上一位读者的留言。",
    cover:
      "https://readdy.ai/api/search-image?query=book%20drift%20reading%20abstract%20collage%20of%20open%20book%20and%20paper%20plane%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-13-2026&orientation=landscape",
    author: "瓜田人物组",
    publishedAt: "2026-08-31",
    readMinutes: 5,
    views: 6890,
    heat: 688,
    tags: ["公益", "阅读", "暖心"],
    content: [
      {
        text: "这个计划的起点很朴素：顾星野在一家咖啡馆看到书架上落灰的旧书，问店主能不能让它们走出去。第一本漂流书就是这样离开的。",
      },
      {
        heading: "一本会旅行的书",
        text: "每本漂流书里都夹着一张卡片，读者可以在上面写下读到某页时的想法，然后把书留给下一个人。有人统计过，一本书最多被传过十一次。",
      },
      {
        heading: "让善意变得具体",
        text: "顾星野说，他不想把这件事说得太大。让一本书找到下一个读者，让一句留言被陌生人读到，这些具体的、微小的连接，本身就足够有意义。",
      },
    ],
  },
  {
    id: "sci-fi-2026-outlook",
    title: "2026 科幻片单前瞻：国产科幻正在尝试更小的切口",
    category: "film",
    excerpt:
      "不再只盯着星辰大海，一批新片把科幻放在更近的地方：一间公寓、一段记忆、一次普通的告别。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20sci-fi%20abstract%20collage%20of%20orbiting%20rings%20and%20apartment%20window%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=1200&height=800&seq=art-14-2026&orientation=landscape",
    author: "瓜田影视组",
    publishedAt: "2026-08-30",
    readMinutes: 6,
    views: 9520,
    heat: 808,
    tags: ["科幻", "片单", "前瞻"],
    trending: true,
    content: [
      {
        text: "梳理接下来一年值得关注的科幻片单，会发现一个明显的变化：大场面依然有，但更多创作者开始把科幻放进日常的尺度里。",
      },
      {
        heading: "从宇宙回到客厅",
        text: "几部备受期待的新片，故事都发生在很小的空间：一间会记录住客记忆的公寓，一段被反复回放的对话。科幻不再是背景板，而是推动人物做选择的那个变量。",
      },
      {
        heading: "小切口，考验的是情感",
        text: "当特效不再是唯一卖点，故事对情感的依赖就更重。这也意味着，观众会更容易在其中看到自己，而不是只惊叹于画面。",
      },
      {
        text: "当然，小切口并不等于低制作。相反，把有限的预算集中在一两个关键场景上，往往能换来更耐看的细节。",
      },
    ],
  },
];